<template>
  <div id="app">
    <!-- <img src="./assets/logo.png"> -->
        <transition name="rotate-fall">
             <router-view class="app-router-view"/>
        </transition>

  </div>
</template>

<script>
import 'vue-transition.css'

export default {
  name: 'App',
}
</script>

<style>
#app{
   font-family: "Helvetica Neue",Helvetica,"PingFang SC","Hiragino Sans GB","Microsoft YaHei","微软雅黑",Arial,sans-serif;
   min-width: 1200px;;
}

.app  .app-router-view{
    position: absolute;
    top: 0;
    left: 0;
    bottom: 0;
    right: 0;
    overflow: hidden;
    backface-visibility: hidden;
    transform: translate3d(0, 0, 0);
    transform-style: preserve-3d;
    visibility: visible;
}

.el-input__icon{
  font-size: 18px!important
}
.el-drawer__body{
  overflow: auto;
}

</style>



// WEBPACK FOOTER //
// src/App.vue